import { render, staticRenderFns } from "./LogsComp.vue?vue&type=template&id=786ff0dc&"
import script from "./LogsComp.vue?vue&type=script&lang=js&"
export * from "./LogsComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports